import {all} from 'redux-saga/effects';
import * as actions from './';
import * as sdk from 'sdk/locations';
import {createFetchSagaLatest} from 'utils/sagas';

function* locationListSaga() {
  yield all([
    createFetchSagaLatest(actions.fetchLocations, sdk.fetchLocations)
  ]);
}

export default locationListSaga;
